import { inject } from '@angular/core';
import { HttpRequest, HttpErrorResponse, HttpEvent, HttpResponse, HttpInterceptorFn, HttpHandlerFn, HttpContextToken } from '@angular/common/http';
import { tap } from 'rxjs/operators';
import { Loggers, PERFORMANCE } from '../../express.tokens';
import { HttpTimeoutError } from './http-timeout.interceptor';
import { getLogger } from '@knorr-bremse-portals/ngx-components';

export const EXPECTED_HTTP_STATUS_CODES = new HttpContextToken<number[]>(() => []);

export function provideHttpLoggerInterceptor(): HttpInterceptorFn {
  return (req: HttpRequest<unknown>, next: HttpHandlerFn) => {

    const httpLogger = getLogger(Loggers.HttpClient);
    const performanceLogger = getLogger(Loggers.Performance);
    const performance = inject(PERFORMANCE);

    httpLogger.info('Http request', { url: req.url });
    const startTime = performance.now();

    return next(req).pipe(
      tap({
        next: (res: HttpEvent<unknown>) => {
          if (res instanceof HttpResponse) {
            httpLogger.debug('Http response', { status: res.status, url: res.url });
          }
        },
        error: (error) => {
          if (error instanceof HttpErrorResponse) {
            const message = 'Failed to do http request';

            if (req.context.get(EXPECTED_HTTP_STATUS_CODES)?.includes(error.status)) {
              httpLogger.debug(message, {
                status: error.status,
                url: error.url,
                errorMessage: error.message,
                errorStack: error.error,
              });
              return;
            }

            httpLogger.error(message, {
              status: error.status,
              url: error.url,
              errorMessage: error.message,
              errorStack: error.error,
            });
          } else if (error instanceof HttpTimeoutError) {
            httpLogger.error(error.message, {
              method: error.request.method,
              url: error.request.urlWithParams,
            });
          } else {
            httpLogger.error('Failed to do http request (network ok)', { error });
          }
        },
        complete: () => {
          const time = (performance.now() - startTime);
          const message = `Http Client Request to "${req.url}" took ${time.toFixed(2)}ms`;
          if (time <= 400) {
            performanceLogger.debug(message);
          } else if(time <= 1000) {
            performanceLogger.info(message);
          } else if(time <= 2000) {
            performanceLogger.notice(message);
          } else {
            performanceLogger.warning(message);
          }
        },
      }),
    );
  }
}
